import * as api from '../resources/terms-of-use.api';
import ationTypes from './terms-of-use.action-types';

export const fetchTermsOfUseRequest = () => ({
  type: ationTypes.FETCH_TERMS_OF_USE_REQUEST,
  name: 'termsOfUseLoadingStatus',
  hasError: false,
});

export const fetchTermsOfUseSuccess = (content) => ({
  type: ationTypes.FETCH_TERMS_OF_USE_SUCCESS,
  name: 'termsOfUseLoadingStatus',
  hasError: false,
  content,
});

export const fetchTermsOfUseFailure = () => ({
  type: ationTypes.FETCH_TERMS_OF_USE_FAILURE,
  name: 'termsOfUseLoadingStatus',
  hasError: true,
});

export const fetchTermsOfUse = () => async (dispatch) => {
  try {
    dispatch(fetchTermsOfUseRequest());
    const content = await api.fetchTermsOfUse();
    dispatch(fetchTermsOfUseSuccess(content));
  } catch (error) {
    console.error('FETCH_TERMS_OF_USE', error);
    dispatch(fetchTermsOfUseFailure());
  }
};

export const downloadTermsOfUseRequest = () => ({
  type: ationTypes.DOWNLOAD_TERMS_OF_USE_REQUEST,
});

export const downloadTermsOfUseSuccess = () => ({
  type: ationTypes.DOWNLOAD_TERMS_OF_USE_SUCCESS,
});

export const downloadTermsOfUseFailure = () => ({
  type: ationTypes.DOWNLOAD_TERMS_OF_USE_FAILURE,
});

export const downloadTermsOfUse = () => async (dispatch, getState) => {
  try {
    const { termsOfUse, session } = getState();
    const { locale } = session;
    const { attachments } = termsOfUse;

    const contentId = attachments[locale][0].id;
    const filename = attachments[locale][0].name;

    dispatch(downloadTermsOfUseRequest());

    const report = await api.downloadTermsOfUse(contentId);
    const result = await report.promise;

    window.saveAs(result.data, filename);

    dispatch(downloadTermsOfUseSuccess());
  } catch (error) {
    console.error('DOWNLOAD_TERMS_OF_USE', error);
    dispatch(downloadTermsOfUseFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/actions/terms-of-use.actions.js